import { styled } from '@mui/system';

export const PackageContainer = styled('div')(({ theme }) => ({
	display: 'block',
	marginBottom: theme.spacing(0.5),
	[theme.breakpoints.down('sm')]: {
		marginLeft: 0
	}
}));

export const LinkContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	marginBottom: theme.spacing(0.5),
	alignItems: 'center'
}));

export const ImageContainer = styled('div')(({ theme }) => ({
	marginTop: 15,
	marginBottom: 15
}));
